import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { NoWeb3AuthGuard } from 'modules/auth/components/NoWeb3AuthGuard';
import { Page } from 'modules/layout/components/Page';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { homeRoutesConfig } from 'domains/home/routes';

const PlatformSwaggerPage = loadable(
  () =>
    import('./PlatformSwaggerPage').then(module => module.PlatformSwaggerPage),
  {
    fallback: <OverlaySpinner />,
  },
);

const homePath = homeRoutesConfig.home.generatePath();
const chainsPath = chainsRoutesConfig.chains.generatePath();

export const PlatformSwaggerPageContainer = () => {
  return (
    <Page>
      <NoSSRGuard>
        <LoggingInGuard fallback={<Navigate to={chainsPath} />}>
          <NoWeb3AuthGuard fallback={<Navigate to={homePath} />}>
            <PlatformSwaggerPage />
          </NoWeb3AuthGuard>
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
